export const API_URL = process.env.GATSBY_API_URL

export const PLATFORM_BASE_URL = process.env.GATSBY_PLATFORM_BASE_URL
